import { TableCell } from '@toggle/design-system';
import React from 'react';

import * as S from './LoaderCell.styles';

export const LoaderCell = ({ numberOfRows }: { numberOfRows: number }) => {
  return (
    <>
      {Array.from({ length: numberOfRows }).map((_, index) => {
        return (
          <tr key={`tr-${index}`} style={{ width: '100%' }}>
            <TableCell alignment="left">
              <S.RankLoader />
            </TableCell>
            <TableCell alignment="left">
              <S.FlexRow>
                <S.LogoLoader />
                <S.ThemeNameLoader $width={`${114 + index * 30}px`} />
              </S.FlexRow>
            </TableCell>
            <TableCell alignment="left">
              <S.DescriptionLoader />
            </TableCell>
          </tr>
        );
      })}
    </>
  );
};
